module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/dj-agent-3638c7c9b465c0a333bde43227f88b11.png";